//on-offボタン
export class OnOffButton extends EventTarget{
    onElem;
    offElem;
    simpleElem;
    buttonElem;
    constructor(buttonID:string, initialState:'on'|'off' = 'off'){
        super();    //'this'を使う前にsuper()を実行する必要がある
        this.buttonElem = document.getElementById(buttonID);    //ボタン要素
        if (this.buttonElem){
            this.offElem = document.querySelector('#'+buttonID+' .btnOff');
            if(this.offElem){
                this.offElem.addEventListener("click", (e: Event) => {
                    this.SetOn();
                });
            }
            //ONボタン
            this.onElem = document.querySelector('#'+buttonID+' .btnOn');
            if(this.onElem){
                this.onElem.addEventListener("click", (e: Event) => {
                    this.SetOff();
                });
            }
            //シンプルボタン
            if(this.offElem == null && this.onElem == null){
                this.simpleElem = document.querySelector('#'+buttonID+' button');
                if(this.simpleElem){
                    //console.log("simpleElement found");
                    this.simpleElem.addEventListener("click", (e: Event) => {
                        this.SimpleClick();
                    });
                }
            }              
        }
        //ボタンの初期ルック
        //console.log(buttonID, initialState);
        //this.Show();
        if(initialState == 'on'){
            this.SetOn();
        }else{
            this.SetOff();
        }
    }

    SetOn(){
        //console.log('setOn');
        let event = new CustomEvent("on");
        this.dispatchEvent(event);
        this.LookOn();
    }
    LookOn(){
        if(this.onElem) this.onElem.style.display = 'block';
        if(this.offElem) this.offElem.style.display = 'none';
    }

    SetOff(){
        //console.log('setOff');
        let event = new CustomEvent("off");
        this.dispatchEvent(event);
        this.LookOff();
    }
    LookOff(){
        if(this.onElem) this.onElem.style.display = 'none';
        if(this.offElem) this.offElem.style.display = 'block';
    }

    SimpleClick(){
        //console.log('SimpleClick');
        let event = new CustomEvent("simple");
        this.dispatchEvent(event);
    }

    Show(){
        if(this.buttonElem) this.buttonElem.style.display = 'block';
    }
    Hide(){
        if(this.buttonElem) this.buttonElem.style.display = 'none';
    }
}
